import React, { useState, useEffect, useMemo } from 'react';
import { Spin, Tabs, Skeleton } from 'antd';
import styled from 'styled-components';
import BookDetailContent from './BookDetailContent';
import Marc21 from './Marc21';
import DocStore from './DocStore';
import BookChapter from './BookChaper';
import ReadBook from './ReadBook';
import { getRecordContentApi } from './ApiService';
import BookQRCode from './QRCode';
import { QR_CODE_KEY } from '../../shared/constants/defaultVariables.consants';

const Wrapper = styled.div``;

const Title = styled.div`
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #d6e9c6;
  border-radius: 4px;
  padding: 10px;
  text-align: center;
`;

const BookCover = styled.div`
  gap: 8px;
  padding: 12px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

const TabWrapper = styled.div`
  padding: ${({ isPage }) => (isPage ? '4px 12px' : '0')};
`;

const BookImgWrapper = styled.a`
  display: block;
  width: 150px;
`;

const ZlisSpin = styled(Spin)`
  padding: 20px;
  text-align: center;
  width: 100%;
`;

function BookInfo({ id, isPage }) {
  const [detailContent, setDetailContent] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const getConent = () => {
    setIsLoading(true);
    const params = { id, type: 'field' };
    getRecordContentApi(params)
      .then((data) => setDetailContent(data))
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getConent();
  }, []);

  const bookTitle = useMemo(
    () => detailContent?.find((item) => item.Tag === '245')?.Value[0],
    [detailContent]
  );

  const bookCover = useMemo(
    () => detailContent?.find((item) => item.Tag === 'BookCover'),
    [detailContent]
  );

  const bookQrCode = useMemo(
    () => detailContent?.find((item) => item.Tag === 'QrCode'),
    [detailContent]
  );

  const tabItems = [
    {
      label: 'Nội dung chi tiết',
      key: 'content',
      children: <BookDetailContent contentList={detailContent} />,
    },
    {
      label: 'MARC21',
      key: 'marc',
      children: <Marc21 id={id} />,
    },
    {
      label: 'Kho Tài liệu',
      key: 'inv',
      children: <DocStore id={id} />,
    },
    {
      label: 'Mục lục',
      key: 'chapter',
      children: <BookChapter id={id} />,
    },
    {
      label: 'Đọc sách',
      key: 'readBook',
      children: <ReadBook id={id} />,
    },
  ];

  return (
    <Wrapper>
      {isLoading ? (
        <Skeleton avatar paragraph={{ rows: 4 }} />
      ) : (
        <>
          <Title>{bookTitle}</Title>
          {bookCover && (
            <BookCover>
              <BookImgWrapper
                href={bookCover.Value}
                data-lightbox="psc"
                data-title=""
              >
                <img src={bookCover.Value} alt="Cover" />
              </BookImgWrapper>
              {bookQrCode && (
                <>
                  <BookQRCode
                    url={`${window.getZlisApi()}module/chi-tiet-sach?RecordID=${id}`}
                    text="Thông tin sách"
                  />
                  {!window.shouldHideReactAppQRCode ||
                  !window.shouldHideReactAppQRCode() ? (
                    <BookQRCode
                      url={`https://psczlis.azurewebsites.net/mobileapp.html?id=${
                        window.getQRCodeAppId
                          ? window.getQRCodeAppId()
                          : QR_CODE_KEY
                      }`}
                      text="App Thư viện"
                    />
                  ) : null}
                </>
              )}
            </BookCover>
          )}
          <TabWrapper isPage={isPage}>
            <Tabs defaultActiveKey="1" items={tabItems} />
          </TabWrapper>
        </>
      )}
    </Wrapper>
  );
}

export default BookInfo;
